export default {"src":"/_next/static/media/Deactivate.c3e3c5bc.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};